export const focusOnElementOrNextFocussableElement = (id: string) => {
  var allFocusableElements =
    'a:not([disabled]), button:not([disabled]):not([style*="display:none"]), input:not([disabled]):not([style*="display:none"]), select:not([disabled]):not([style*="display:none"]), [tabindex]:not([disabled]):not([tabindex="-1"]):not([style*="display:none"])';
  var elements = window.document.querySelectorAll(
    `#${id}, ` + allFocusableElements
  );

  var elementArray = Array.prototype.slice.call(elements) as HTMLInputElement[];
  var currentIndex = elementArray.findIndex((element) => element.id === id);

  if (!currentIndex) {
    return;
  }

  // We have found the element with id and we can focus on it
  var currentElement = elementArray[currentIndex];

  if (!currentElement.disabled) {
    currentElement.focus();
    return;
  }

  // We have found the element with id but it is disabled so we need to focus on the next element that is not disabled
  if (currentIndex + 1 < elementArray.length - 1) {
    var nextElement = elementArray[currentIndex + 1];
    nextElement.focus();
  }
};
